import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as actions from './actions';
import { useActions } from 'hooks/useActions';
import { Button } from 'components/Button/RoundButton';
import { Form, Input, Label, InfoText } from 'components/FormComponents/FormComponents';
import { Container, Wrapper, Header } from 'components/Layout/Layout';
import CurvedContainer from 'components/CurvedContainer/CurvedContainer';
import { colors } from 'global/colors';

export default function GDPRDeletionPage() {
  const [email, setEmail] = useState('');

  const { createGDPRDeletionRequest } = useActions(actions);
  const { GDPRResponse, error } = useSelector((state) => state.GDPROptOutPageReducer);

  return (
    <Wrapper>
      <CurvedContainer bottom height={110} color={colors.fsDarkBlue}></CurvedContainer>
      <Container color={colors.lightGray} half column>
        <Header>GDPR delete me</Header>
        <Label margin="0 0 25px">
          Enter your email below and press submit in order to get an email with a link that you can use to remove all
          your personal information from Future Skills systems in accordance with the General Data Protection Regulation
          (GDPR) laws.
        </Label>
        <Label margin="0 0 25px">
          Note that this will remove all of your information from Future Skills systems, and will impact all companies
          that have sent tests to you, as well as remove your participation from any community activities.
        </Label>
        <Form onSubmit={() => createGDPRDeletionRequest(email)}>
          <Input
            autoFocus
            disabled={GDPRResponse}
            placeholder="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <InfoText error>{error}</InfoText>}
          {GDPRResponse && <InfoText success>A link has been sent to the email you entered</InfoText>}
          <Button primary type="submit" disabled={!email || GDPRResponse}>
            Submit
          </Button>
        </Form>
      </Container>
    </Wrapper>
  );
}
